export default __webpack_public_path__ + "static/media/profile-red.6dffafd9.svg";